export const LOGO_RED =
  'https://file.meilisci.com/resource/Joymel_logo_red.png';
export const LOGO_WHITE =
  'https://file.meilisci.com/resource/Joymel_logo_white.png';
export const PLACEHOLDER_IMG =
  'https://file.meilisci.com/resource/packaging-placeholder-img.png';
export const PLACEHOLDER_IMG_BIG =
  'https://file.meilisci.com/resource/packaging-placeholder-img-big.png';
export const LOGO_IMG = 'https://file.meilisci.com/beukaylogo%402x.png';

// 打点应用ID
export const TRACE_APP_ID = 403726;

// 登出后不跳转登录页的白名单
export const logout2loginWhite = [
  {
    path: '/',
  },
  {
    path: '/search',
  },
  {
    path: '/product/:spuCode',
  },
];
export const SHIP_REGION = 'SHIP_REGION';
export const NOT_IN_BRAND_AUTH_AREA = 'NOT_IN_BRAND_AUTH_AREA';
export const ORDER_STEPS = [
  { step: 1, label: '1 购物车结算' },
  { step: 2, label: '2 确定订单信息' },
  { step: 3, label: '3 成功提交订单' },
];

export const DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const D_DATE_FORMAT = 'YYYY-MM-DD';

export const APP_SOURCE = 'PACKAGING_MATERIALS_MALL';
